/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class DataSourceEditor {
  async Save(reportGU : string, queryType : string, query : string, columns : Array<string>, parameters : Array<string>) : Promise<any> {
    return await componentApi.call('st', 'ko-data-source-editor', 'DataSourceEditor', 'Save', {
      reportGU,
      queryType,
      query,
      columns,
      parameters,
    });
  }
  async GetDataSourceInfo(reportGU : string) : Promise<st.DataSourceInfo> {
    return await componentApi.call('st', 'ko-data-source-editor', 'DataSourceEditor', 'GetDataSourceInfo', {
      reportGU,
    });
  }
}
export default new DataSourceEditor()
